import React, { useEffect } from 'react'
import { Header, FaqSection, SplitSection, Footer } from '@wallyhealth/web-core'
import intelService from '../../services/intelService'
import Setup from './Setup'
import faqs from './faqs.js'
import CareTips from './CareTips'
import styles from './index.module.css'
import heroImgSrc from './hero.jpg'

const NightGuardPage = () => {
  useEffect(() => {
    intelService.recordView({ viewName: 'NightGuardPage' })
  }, [])

  return (
    <div className={styles.container}>
      <Header />
      <SplitSection
        title="Your Guide to Night Guard."
        description="Follow the steps below to set up and maintain your guard."
        imageSrc={heroImgSrc}
        titleClassName={styles.title}
      />
      <Setup />
      <CareTips />
      <FaqSection
        items={faqs}
      />
      <Footer />
    </div>
  )
}

export default NightGuardPage
